module.exports = __webpack_public_path__ + "img/carousel1.f45905a0.png";